// UserValidation.ts

import { Staff } from "./Staff.type";

export const validateStaffForm = (user: Staff) => {
  const requiredFields = [
    "userName",
    "firstName",
    "lastName",
    "phoneNumber",
    "email",
    "dateOfBirth",
    "gender",
    "address",
  ];
  let formErrors: any = {};
  let valid = true;

  requiredFields.forEach((field: string) => {
    const userField = user as any;
    const { valid: fieldValid, error } = validateStaffField(
      field,
      userField[field]
    );
    if (!fieldValid) {
      formErrors[field] = error;
      valid = false;
    }
  });

  return { valid, errors: formErrors };
};

// Function to validate a single field (for use onChange)
export const validateStaffField = (fieldName: String, value: any) => {
  let valid = true;
  let error = "";

  switch (fieldName) {
    case "email":
      if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = "Please enter a valid email address";
        valid = false;
      }
      break;
    case "phoneNumber":
      if (!value || !/^\d{10}$/.test(value)) {
        error = "Please enter a valid 10-digit mobile number";
        valid = false;
      }
      break;
    default:
      if (!value || value.trim() === "") {
        error = `${
          fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
        } is required`;
        valid = false;
      }
      break;
  }

  return { valid, error };
};
